// eslint-disable-next-line import/prefer-default-export
const datefolderStr1 = '2022-05-19'
const datefolderStr = '2022-02-23'

// mattress
const mattressFullNodesMeta = [
    {
        category: 'pillow',
        size: 'full',
        matrixModel: [
            [1.0, 0.0, 0.0, -0.3858965337276459],
            [0.0, 1.0, 0.0, 0.2749449908733368],
            [0.0, 0.0, 1.0, -0.705109179019928],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
    {
        category: 'pillow',
        size: 'full',
        matrixModel: [
            [1.0, 0.0, 0.0, 0.3858965337276459],
            [0.0, 1.0, 0.0, 0.2749449908733368],
            [0.0, 0.0, 1.0, -0.705109179019928],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
    {
        category: 'duvet',
        size: 'full',
        matrixModel: [
            [1.0, 0.0, 0.0, 0.0],
            [0.0, 1.0, 0.0, -0.23533299565315247],
            [0.0, 0.0, 1.0, 0.0],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
]

const mattressKingNodesMeta = [
    {
        category: 'pillow',
        size: 'king',
        matrixModel: [
            [1.0, 0.0, 0.0, -0.46094465255737305],
            [0.0, 1.0, 0.0, 0.2749454379081726],
            [0.0, 0.0, 1.0, -0.7590532898902893],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
    {
        category: 'pillow',
        size: 'king',
        matrixModel: [
            [1.0, 0.0, 0.0, 0.46094465255737305],
            [0.0, 1.0, 0.0, 0.2749454379081726],
            [0.0, 0.0, 1.0, -0.7590532898902893],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
    {
        category: 'duvet',
        size: 'king',
        matrixModel: [
            [1.0, 0.0, 0.0, 0.0],
            [0.0, 1.0, 0.0, -0.2747127413749695],
            [0.0, 0.0, 1.0, 0.0],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
]

const mattressQueenNodesMeta = [
    {
        category: 'pillow',
        size: 'queen',
        matrixModel: [
            [1.0, 0.0, 0.0, -0.3812639117240906],
            [0.0, 1.0, 0.0, 0.2749449908733368],
            [0.0, 0.0, 1.0, -0.7585901618003845],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
    {
        category: 'pillow',
        size: 'queen',
        matrixModel: [
            [1.0, 0.0, 0.0, 0.3812639117240906],
            [0.0, 1.0, 0.0, 0.2749449908733368],
            [0.0, 0.0, 1.0, -0.7585901618003845],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
    {
        category: 'duvet',
        size: 'queen',
        matrixModel: [
            [1.0, 0.0, 0.0, 0.0],
            [0.0, 1.0, 0.0, -0.26042911410331726],
            [0.0, 0.0, 1.0, 0.0],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
]

const mattressTwinNodesMeta = [
    {
        category: 'pillow',
        size: 'twin',
        matrixModel: [
            [1.0, 0.0, 0.0, 0.0],
            [0.0, 1.0, 0.0, 0.2749449908733368],
            [0.0, 0.0, 1.0, -0.6942226886749268],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
    {
        category: 'duvet',
        size: 'twin',
        matrixModel: [
            [1.0, 0.0, 0.0, 0.0],
            [0.0, 1.0, 0.0, -0.2191503643989563],
            [0.0, 0.0, 1.0, 0.0],
            [0.0, 0.0, 0.0, 1.0],
        ],
    },
]

const duvetFullFootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/duvet/full/duvet-full-bed_with_footrest.glb`
const duvetFullPlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/duvet/full/duvet-full-platform_bed.glb`
const duvetKingFootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/duvet/king/duvet-king-bed_with_footrest.glb`
const duvetKingPlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/duvet/king/duvet-king-platform_bed.glb`
const duvetQueenFootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/duvet/queen/duvet-queen-bed_with_footrest.glb`
const duvetQueenPlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/duvet/queen/duvet-queen-platform_bed.glb`
const duvetTwinFootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/duvet/twin/duvet-twin-bed_with_footrest.glb`
const duvetTwinPlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/duvet/twin/duvet-twin-platform_bed.glb`

/* eslint-disable @typescript-eslint/naming-convention */
const duvetne_100_200PlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_100_200/duvet-ne_100_200-platform_bed.glb`
const duvetne_100_200FootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_100_200/duvet-ne_100_200-bed_with_footrest.glb`
const duvetne_140_200PlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_140_200/duvet-ne_140_200-platform_bed.glb`
const duvetne_140_200FootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_140_200/duvet-ne_140_200-bed_with_footrest.glb`
const duvetne_160_200PlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_160_200/duvet-ne_160_200-platform_bed.glb`
const duvetne_160_200FootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_160_200/duvet-ne_160_200-bed_with_footrest.glb`
const duvetne_180_200PlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_180_200/duvet-ne_180_200-platform_bed.glb`
const duvetne_180_200FootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_180_200/duvet-ne_180_200-bed_with_footrest.glb`
const duvetne_200_200PlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_200_200/duvet-ne_200_200-platform_bed.glb`
const duvetne_200_200FootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_200_200/duvet-ne_200_200-bed_with_footrest.glb`
const duvetne_80_200PlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_80_200/duvet-ne_80_200-platform_bed.glb`
const duvetne_80_200FootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_80_200/duvet-ne_80_200-bed_with_footrest.glb`
const duvetne_90_200PlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_90_200/duvet-ne_90_200-platform_bed.glb`
const duvetne_90_200FootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/ne_90_200/duvet-ne_90_200-bed_with_footrest.glb`
const duvetuk_doublePlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/uk_double/duvet-uk_double-platform_bed.glb`
const duvetuk_doubleFootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/uk_double/duvet-uk_double-bed_with_footrest.glb`
const duvetuk_kingPlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/uk_king/duvet-uk_king-platform_bed.glb`
const duvetuk_kingFootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/uk_king/duvet-uk_king-bed_with_footrest.glb`
const duvetuk_singlePlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/uk_single/duvet-uk_single-platform_bed.glb`
const duvetuk_singleFootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/uk_single/duvet-uk_single-bed_with_footrest.glb`
const duvetuk_super_kingPlatformUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/uk_super_king/duvet-uk_super_king-platform_bed.glb`
const duvetuk_super_kingFootrestUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/duvet/uk_super_king/duvet-uk_super_king-bed_with_footrest.glb`
/* eslint-enable @typescript-eslint/naming-convention */

const mattressFullUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/mattress/full/mattress-full.glb`
const mattressKingUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/mattress/king/mattress-king.glb`
const mattressQueenUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/mattress/queen/mattress-queen.glb`
const mattressTwinUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/mattress/twin/mattress-twin.glb`

/* eslint-disable @typescript-eslint/naming-convention */
const mattressne_100_200Url = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/ne_100_200/mattress-ne_100_200.glb`
const mattressne_140_200Url = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/ne_140_200/mattress-ne_140_200.glb`
const mattressne_160_200Url = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/ne_160_200/mattress-ne_160_200.glb`
const mattressne_180_200Url = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/ne_180_200/mattress-ne_180_200.glb`
const mattressne_200_200Url = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/ne_200_200/mattress-ne_200_200.glb`
const mattressne_80_200Url = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/ne_80_200/mattress-ne_80_200.glb`
const mattressne_90_200Url = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/ne_90_200/mattress-ne_90_200.glb`
const mattressuk_doubleUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/uk_double/mattress-uk_double.glb`
const mattressuk_kingUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/uk_king/mattress-uk_king.glb`
const mattressuk_singleUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/uk_single/mattress-uk_single.glb`
const mattressuk_super_kingUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr}/mattress/uk_super_king/mattress-uk_super_king.glb`
/* eslint-enable @typescript-eslint/naming-convention */

const pillowFullUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/pillow/full/pillow-full.glb`
const pillowKingUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/pillow/king/pillow-king.glb`
const pillowQueenUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/pillow/queen/pillow-queen.glb`
const pillowTwinUrl = `https://storage.googleapis.com/catalog-processed/dressed-beds/${datefolderStr1}/pillow/twin/pillow-twin.glb`

const createFakeDuvet = (id, size, variant, modelUrl) => ({
    id,
    hidden: true,
    region: 'geo',
    name: '00FAKEDUVET',
    thumbUrl: 'https://www.ikea.com/us/en/images/products/alseda-stool-banana-fiber__24302_pe089431_s5.jpg',
    collections: ['IKEA', 'Debug'],
    rootCategories: [],
    categories: ['Debug'],
    subCategories: ['Debug'],
    ecommerceUrl: '',
    globalProductId: 'GEO1112',
    price: '$39.99',
    rating: '0.0',
    ratingCount: 0,
    description: 'Fake combinable item',
    imageUrls: [
        'https://www.ikea.com/us/en/images/products/alseda-stool-banana-fiber__24302_pe089431_s5.jpg',
        'https://www.ikea.com/us/en/images/products/alseda-stool-banana-fiber__1097696_ph173556_s5.jpg',
        'https://www.ikea.com/us/en/images/products/alseda-stool-banana-fiber__1059353_pe849594_s5.jpg',
    ],
    qaStatus: 'PENDING',
    availableInRegion: true,
    uncompressedModelSize: 0,
    localItemNumber: '20033919',
    recommended: [],
    subCatalogs: null,
    swappableItems: null,
    modelUrl,
    rotX: 1.5707963267949,
    scale: 1,
    geometryType: '3d',
    maxX: 0.302869498729706,
    maxY: 0.163490742561407,
    maxZ: 0.30346742272377,
    minX: -0.303461700677872,
    minY: 0,
    minZ: -0.30165821313858,
    stackables: null,
    metadata: {
        combinables: {
            selfMeta: { category: 'duvet', size, variant },
            nodesMeta: [],
        },
    },
})

const createFakeMattress = (id, size, nodesMeta, modelUrl) => ({
    id,
    hidden: true,
    region: 'geo',
    name: '00FAKEMATTRESS',
    thumbUrl:
        'https://www.ikea.com/us/en/images/products/aepplaroe-table-stool-section-outdoor-brown-stained__0736462_pe740546_s5.jpg',
    collections: ['IKEA', 'Debug'],
    rootCategories: [],
    categories: [],
    subCategories: ['Debug'],
    ecommerceUrl: '',
    globalProductId: '80213446',
    price: '$55.00',
    rating: '0.0',
    ratingCount: 0,
    description: 'Fake combinable item',
    imageUrls: [
        'https://www.ikea.com/us/en/images/products/aepplaroe-table-stool-section-outdoor-brown-stained__0736462_pe740546_s5.jpg',
        'https://www.ikea.com/us/en/images/products/aepplaroe-table-stool-section-outdoor-brown-stained__0673536_pe717303_s5.jpg',
        'https://www.ikea.com/us/en/images/products/aepplaroe-table-stool-section-outdoor-brown-stained__0673539_pe717311_s5.jpg',
        'https://www.ikea.com/us/en/images/products/aepplaroe-table-stool-section-outdoor-brown-stained__0917930_ph166330_s5.jpg',
        'https://www.ikea.com/us/en/images/products/aepplaroe-table-stool-section-outdoor-brown-stained__0706058_ph141986_s5.jpg',
        'https://www.ikea.com/us/en/images/products/aepplaroe-table-stool-section-outdoor-brown-stained__0907955_pe617526_s5.jpg',
        'https://www.ikea.com/us/en/images/products/aepplaroe-table-stool-section-outdoor-brown-stained__0907980_pe619789_s5.jpg',
        'https://www.ikea.com/us/en/images/products/aepplaroe-table-stool-section-outdoor-brown-stained__0907951_pe616541_s5.jpg',
    ],
    qaStatus: 'PENDING',
    availableInRegion: true,
    uncompressedModelSize: 0,
    localItemNumber: '80213446',
    recommended: [],
    subCatalogs: null,
    swappableItems: null,
    modelUrl,
    rotX: 1.5707963267949,
    scale: 1,
    geometryType: '3d',
    maxX: 0.313216686248779,
    maxY: 0.28579631447792,
    maxZ: 0.313265472650528,
    minX: -0.313233524560928,
    minY: 0,
    minZ: -0.313269466161728,
    stackables: null,
    isRug: false,
    selected: true,
    isLeftMost: true,

    metadata: {
        combinables: {
            selfMeta: { category: 'mattress', size },
            nodesMeta,
        },
    },
})

const createFakePillow = (id, size, modelUrl) => ({
    id,
    hidden: true,
    region: 'geo',
    name: '00FAKEPILLOW',
    thumbUrl: 'https://www.ikea.com/us/en/images/products/alseda-stool-banana-fiber__24302_pe089431_s5.jpg',
    collections: ['IKEA', 'Debug'],
    rootCategories: [],
    categories: ['Debug'],
    subCategories: ['Debug'],
    ecommerceUrl: '',
    globalProductId: 'GEO1112',
    price: '$39.99',
    rating: '0.0',
    ratingCount: 0,
    description: 'Fake combinable item',
    imageUrls: [
        'https://www.ikea.com/us/en/images/products/alseda-stool-banana-fiber__24302_pe089431_s5.jpg',
        'https://www.ikea.com/us/en/images/products/alseda-stool-banana-fiber__1097696_ph173556_s5.jpg',
        'https://www.ikea.com/us/en/images/products/alseda-stool-banana-fiber__1059353_pe849594_s5.jpg',
    ],
    qaStatus: 'PENDING',
    availableInRegion: true,
    uncompressedModelSize: 0,
    localItemNumber: '20033919',
    recommended: [],
    subCatalogs: null,
    swappableItems: null,
    modelUrl,
    rotX: 1.5707963267949,
    scale: 1,
    geometryType: '3d',
    maxX: 0.302869498729706,
    maxY: 0.163490742561407,
    maxZ: 0.30346742272377,
    minX: -0.303461700677872,
    minY: 0,
    minZ: -0.30165821313858,
    stackables: null,
    metadata: {
        combinables: {
            selfMeta: { category: 'pillow', size },
            nodesMeta: [],
        },
    },
})

let id = 9999990
/* eslint-disable no-plusplus */
const mockCombinableChildren = [
    createFakeDuvet(id++, 'full', 'bed_with_footrest', duvetFullFootrestUrl), // fakeDuvetFullFootrest,
    createFakeDuvet(id++, 'full', 'platform_bed', duvetFullPlatformUrl), // fakeDuvetFullPlatform,
    createFakeDuvet(id++, 'king', 'bed_with_footrest', duvetKingFootrestUrl), // fakeDuvetKingFootrest,
    createFakeDuvet(id++, 'king', 'platform_bed', duvetKingPlatformUrl), // fakeDuvetKingPlatform,
    createFakeDuvet(id++, 'queen', 'bed_with_footrest', duvetQueenFootrestUrl), // fakeDuvetQueenFootrest,
    createFakeDuvet(id++, 'queen', 'platform_bed', duvetQueenPlatformUrl), // fakeDuvetQueenPlatform,
    createFakeDuvet(id++, 'twin', 'bed_with_footrest', duvetTwinFootrestUrl), // fakeDuvetTwinFootrest,
    createFakeDuvet(id++, 'twin', 'platform_bed', duvetTwinPlatformUrl), // fakeDuvetTwinPlatform,

    createFakeMattress(id++, 'full', mattressFullNodesMeta, mattressFullUrl), // fakeMattressFull,
    createFakeMattress(id++, 'king', mattressKingNodesMeta, mattressKingUrl), // fakeMattressKing,
    createFakeMattress(id++, 'queen', mattressQueenNodesMeta, mattressQueenUrl), // fakeMattressQueen,
    createFakeMattress(id++, 'twin', mattressTwinNodesMeta, mattressTwinUrl), // fakeMattressTwin,

    createFakePillow(id++, 'full', pillowFullUrl), // fakePillowFull,
    createFakePillow(id++, 'king', pillowKingUrl), // fakePillowKing,
    createFakePillow(id++, 'queen', pillowQueenUrl), // fakePillowQueen,
    createFakePillow(id++, 'twin', pillowTwinUrl), // fakePillowTwin,

    createFakeDuvet(id++, 'ne_80_200', 'bed_with_footrest', duvetne_80_200FootrestUrl),
    createFakeDuvet(id++, 'ne_80_200', 'platform_bed', duvetne_80_200PlatformUrl),
    createFakeDuvet(id++, 'ne_90_200', 'bed_with_footrest', duvetne_90_200FootrestUrl),
    createFakeDuvet(id++, 'ne_90_200', 'platform_bed', duvetne_90_200PlatformUrl),
    createFakeDuvet(id++, 'ne_100_200', 'bed_with_footrest', duvetne_100_200FootrestUrl),
    createFakeDuvet(id++, 'ne_100_200', 'platform_bed', duvetne_100_200PlatformUrl),
    createFakeDuvet(id++, 'ne_140_200', 'bed_with_footrest', duvetne_140_200FootrestUrl),
    createFakeDuvet(id++, 'ne_140_200', 'platform_bed', duvetne_140_200PlatformUrl),
    createFakeDuvet(id++, 'ne_160_200', 'bed_with_footrest', duvetne_160_200FootrestUrl),
    createFakeDuvet(id++, 'ne_160_200', 'platform_bed', duvetne_160_200PlatformUrl),
    createFakeDuvet(id++, 'ne_180_200', 'bed_with_footrest', duvetne_180_200FootrestUrl),
    createFakeDuvet(id++, 'ne_180_200', 'platform_bed', duvetne_180_200PlatformUrl),
    createFakeDuvet(id++, 'ne_200_200', 'bed_with_footrest', duvetne_200_200FootrestUrl),
    createFakeDuvet(id++, 'ne_200_200', 'platform_bed', duvetne_200_200PlatformUrl),
    createFakeDuvet(id++, 'us_king', 'bed_with_footrest', duvetKingFootrestUrl),
    createFakeDuvet(id++, 'us_king', 'platform_bed', duvetKingPlatformUrl),
    createFakeDuvet(id++, 'us_queen', 'bed_with_footrest', duvetQueenFootrestUrl),
    createFakeDuvet(id++, 'us_queen', 'platform_bed', duvetQueenPlatformUrl),
    createFakeDuvet(id++, 'us_full', 'bed_with_footrest', duvetFullFootrestUrl),
    createFakeDuvet(id++, 'us_full', 'platform_bed', duvetFullPlatformUrl),
    createFakeDuvet(id++, 'us_twin', 'bed_with_footrest', duvetTwinFootrestUrl),
    createFakeDuvet(id++, 'us_twin', 'platform_bed', duvetTwinPlatformUrl),
    createFakeDuvet(id++, 'uk_super_king', 'bed_with_footrest', duvetuk_super_kingFootrestUrl),
    createFakeDuvet(id++, 'uk_super_king', 'platform_bed', duvetuk_super_kingPlatformUrl),
    createFakeDuvet(id++, 'uk_king', 'bed_with_footrest', duvetuk_kingFootrestUrl),
    createFakeDuvet(id++, 'uk_king', 'platform_bed', duvetuk_kingPlatformUrl),
    createFakeDuvet(id++, 'uk_double', 'bed_with_footrest', duvetuk_doubleFootrestUrl),
    createFakeDuvet(id++, 'uk_double', 'platform_bed', duvetuk_doublePlatformUrl),
    createFakeDuvet(id++, 'uk_single', 'bed_with_footrest', duvetuk_singleFootrestUrl),
    createFakeDuvet(id++, 'uk_single', 'platform_bed', duvetuk_singlePlatformUrl),

    createFakeMattress(id++, 'us_king', mattressKingNodesMeta, mattressKingUrl),
    createFakeMattress(id++, 'us_queen', mattressQueenNodesMeta, mattressQueenUrl),
    createFakeMattress(id++, 'us_full', mattressFullNodesMeta, mattressFullUrl),
    createFakeMattress(id++, 'us_twin', mattressTwinNodesMeta, mattressTwinUrl),
    createFakeMattress(id++, 'uk_super_king', mattressFullNodesMeta, mattressuk_super_kingUrl),
    createFakeMattress(id++, 'uk_king', mattressFullNodesMeta, mattressuk_kingUrl),
    createFakeMattress(id++, 'uk_double', mattressFullNodesMeta, mattressuk_doubleUrl),
    createFakeMattress(id++, 'uk_single', mattressFullNodesMeta, mattressuk_singleUrl),
    createFakeMattress(id++, 'ne_80_200', mattressFullNodesMeta, mattressne_80_200Url),
    createFakeMattress(id++, 'ne_90_200', mattressFullNodesMeta, mattressne_90_200Url),
    createFakeMattress(id++, 'ne_100_200', mattressFullNodesMeta, mattressne_100_200Url),
    createFakeMattress(id++, 'ne_140_200', mattressFullNodesMeta, mattressne_140_200Url),
    createFakeMattress(id++, 'ne_160_200', mattressFullNodesMeta, mattressne_160_200Url),
    createFakeMattress(id++, 'ne_180_200', mattressFullNodesMeta, mattressne_180_200Url),
    createFakeMattress(id++, 'ne_200_200', mattressFullNodesMeta, mattressne_200_200Url),

    createFakePillow(id++, 'us_king', pillowKingUrl),
    createFakePillow(id++, 'us_queen', pillowQueenUrl),
    createFakePillow(id++, 'us_full', pillowFullUrl),
    createFakePillow(id++, 'us_twin', pillowTwinUrl),
    createFakePillow(id++, 'uk_super_king', pillowFullUrl),
    createFakePillow(id++, 'uk_king', pillowFullUrl),
    createFakePillow(id++, 'uk_double', pillowFullUrl),
    createFakePillow(id++, 'uk_single', pillowFullUrl),
    createFakePillow(id++, 'ne_80_200', pillowFullUrl),
    createFakePillow(id++, 'ne_90_200', pillowFullUrl),
    createFakePillow(id++, 'ne_100_200', pillowFullUrl),
    createFakePillow(id++, 'ne_140_200', pillowFullUrl),
    createFakePillow(id++, 'ne_160_200', pillowFullUrl),
    createFakePillow(id++, 'ne_180_200', pillowFullUrl),
    createFakePillow(id++, 'ne_200_200', pillowFullUrl),
]
/* eslint-enable no-plusplus */

export const getMockCommbinables = (mappingFunc) =>
    mockCombinableChildren.map(mappingFunc).reduce((accum, currItem) => {
        const obj = {}
        Object.assign(obj, ...Object.values(currItem))
        return Object.assign(accum, { [obj.id]: obj })
    }, {})

export const getCombinables = (slotCategory, size, variant) =>
    mockCombinableChildren.filter(
        (child) =>
            child.metadata.combinables.selfMeta.category === slotCategory &&
            child.metadata.combinables.selfMeta.size === size &&
            (child.metadata.combinables.selfMeta.variant === undefined ||
                child.metadata.combinables.selfMeta.variant === variant),
    )
